module.exports = __webpack_public_path__ + "static/media/tyler.5ee21afa.jpg";